import { ICoverage, ICoverageAmount } from '../../common/interface/IPayload';
import { ECoverages } from '../../common/interface/IAppProvider';
/**
 Returns an array of coverages
 */
export const getCoverages = (coverages: Array<any>): Array<ICoverage> => {
    return coverages.map((item: any) => {
        return { name: item.name };
    });
};

/**
 Returns an array of coverages with a single amount based on employees
 */
export const getCoverageAmounts = (coverages: Array<any>, employees: number): Array<ICoverageAmount> => {
    return coverages.map((item: any) => {
        return { name: item.name, coverageAmount: item.value.filter((i: any) => i.employees === employees)[0].value };
    });
};

/**
 * returns an array of selected additional coverages
 */
export const getAdditionalCoverages = (additionalCoverages: Array<any>, turnover: number | undefined): Array<any> => {
    const mapped: any = [];
    additionalCoverages.forEach((item: any) => {
        // it item not selected or item is GDPR then don't add turnover
        if (!item.selected || item.name === ECoverages.GDPR) {
            mapped.push(item);
        } else {
            mapped.push({ ...item, turnover });
        }
    });
    return mapped;
};
